import { useNavigateForm } from '@/shared/application/hooks'
import { useOffers } from '../application'

const Offers = () => {
  useOffers()
  const { goToCheckout, goToAditionalData } = useNavigateForm()

  return (
    <div>
      <h1>Página de Ofertas</h1>
      <button type="button" onClick={goToCheckout}>
        Checkout
      </button>
      <br />
      <button type="button" onClick={goToAditionalData}>
        Dados Adicionais
      </button>
    </div>
  )
}

export { Offers }
